// Returns true if the URL is internal, false otherwise.
export const isInternal = s => /^\/(?!\/)/.test(s)
